module.exports = __webpack_public_path__ + "media/images/rectangle-15@1x-78218911bc3a50c43cf088a0844408be.png";